import React from 'react'

import Footer, { Navigation } from '@avcan/crystal/components/footer/Footer'

import Layout from 'layouts/map'
import * as Sources from 'layouts/map/sources/context'
import * as NextUtils from 'utils/next'
import useColumns from 'constants/menus/footer'
import { RouterReady } from 'components/misc/RouterReady'

import mock from '/cypress/fixtures/allData.json'

export async function getStaticProps({ locale }) {
    // If we're mocking the API, return the mock data
    if (process.env.NEXT_PUBLIC_MOCK_API === 'true') {
        return {
            props: {
                data: mock,
            },
        }
    }

    return {
        props: {
            data: await Sources.getData(locale),
        },
        revalidate: 60, // in seconds
    }
}

export async function getStaticPaths({ locale }) {
    const paths = [
        {
            params: {
                path: [],
            },
        },
    ]

    return {
        paths: NextUtils.internationalizeStaticPaths(paths),
        fallback: 'blocking',
    }
}

export default function Index({ data }) {
    const columns = useColumns()

    return (
        <Sources.Provider data={data}>
            <RouterReady>
                <Layout />
            </RouterReady>
            <Footer>
                <Navigation columns={columns} />
            </Footer>
        </Sources.Provider>
    )
}
